const analytics = {
    payLoad: {
      PLATFORM: 'platform',
      M_CODE: 'm_code',
      KEY_MESSAGE: "message",
      KEY_CLICK: "click",
      KEY_PUSH_NOTIFICATION_ID: "push_notification_id",
      LOCATION: "location",
      ERROR_REASON: "error_reason",
      REASON: "reason",
      CONSENT_STATUS: "consent_status",
      VERIFY_TYPE: "verify_type",
      APPLICATION_STATUS: "application_status",
      AMOUNT: "amount",
      ACCOUNT_TYPE: "acc_type",
      MODE: "mode",
      PAYMENT_STATUS: "payment_status",
      REF_CODE: "Ref_code",
      FOS_ID: "Fos_id",
      USER_FLOW: "user_flow",
      UDYAM_COUNT: "udyam_count"
    },
    events: {
      APPLY_NOW: "apply_now",
      RESEND_OTP: "resend_otp",
      SEND_INVITE: "send_invite",
      OTP_ENTERED: "otp_entered",
      HOW_IT_WORKS: "how_it_works",
      MY_SUPPLIERS: "my_suppliers",
      PAN_SUBMITTED: "pan_submitted",
      LOGIN_FAILURE: "login_failure",
      MOBILE_ENTERED: "mobile_entered",
      WHATSAPP_OPTIN: "whatsapp_optin",
      CONFIRM_DETAILS: "confirm_details",
      NOT_SERVICEABLE: "not_serviceable",
      PIN_CODE_ENTERED: "pincode_entered",
      MANDATORY_PERMISSION: "permission_screen",
      CONTINUE_APPLICATION: "continue_application",
      PUSH_NOTIFICATION_RECEIVED: "notification_receive",
      PUSH_NOTIFICATION_CLICKED: "eventPushNotificationClicked",
      APPLICATION_STATUS_VIEWED: "application_status_viewed",
      BIZ_SHOP_OUTSIDE_UPLOADED: "biz_shop_image_outside",
      BIZ_SHOP_INSIDE_UPLOADED: "biz_shop_image_inside",
      PAN_NAME_CONFIRMED: "pan_name_confirmed",
      EMAIL_SUBMITTED: "email_submitted",
      START_DIGITAL_KYC: "start_digi_kyc",
      DIGITAL_KYC_COMPLETED: "digi_kyc_complete",
      SKIP_FACE_VERIFY: "skip_face_verify",
      START_FACE_VERIFY: "start_face_verify",
      FACE_VERIFY_COMPLETE: "face_verify_complete",
      GST_ENTERED: "gst_entered",
      GST_SKIPPED: "gst_skipped",
      GST_USER_ENTERED: "gst_username_entered",
      GST_API_DISABLED: "gst_api_disabled",
      BIZ_INFO_PART_1: "biz_info_part1",
      BIZ_INFO_PART_2: "biz_info_part2",
      CAMERA_OPEN: "camera_open",
      BANK_STATEMENT: "bank_statement",
      REVIEW_APPLICATION: "review_application",
      REVIEW_PERSONAL_EDIT_1: "review_personal_edit_1",
      REVIEW_PERSONAL_EDIT_2: "review_personal_edit_2",
      REVIEW_BIZ_EDIT: "review_biz_edit",
      BANK_DETAILS_ENTERED: "bank_details_entered",
      NACH_FORM_DOWNLOADED: "nach_form_downloaded",
      NACH_FORM_UPLOADED: "nach_form_uploaded",
      MANDATE_MODE: "mandate_mode",
      MANDATE_SUCCESS: "mandate_success",
      NACH_MANDATE_SUCCESS: "nach_mandate_success",
      MANDATE_FAILED: "mandate_failed",
      LOAN_AGREEMENT_DOWNLOAD: "loan_agreement_download",
      RESOLVE_DISCREPANCY: "resolve_discrepancy",
      DISCREPANCIES_RESOLVED: "discrepancies_resolved",
      ADD_SUPPLIER: "add_supplier",
      REPAYMENT: "repayment",
      TRANSACTION: "transaction",
      MANUAL_KYC: "manual_kyc",
      APPLICATION_SUBMITTED: "application_submitted",
      SELECT_SUPPLIER: "select_supplier",
      ENTER_PAYMENT_AMOUNT: "enter_payment_amount",
      AUTHORIZE_PAYMENT: "authorize_payment",
      PAYMENT_PROCESSED: 'payment_processed',
      LOCATION_PERMISSION_CHECKED: 'location_permission_checked',
      UDYAM_OTP_TRIGGERED: "udyam_otp_triggered",
      UDYAM_SKIPPED: "udyam_skipped",
      UDYAM_NUMBER_SUBMIT: "udyam_number_submit",
      UDYAM_OTP_VERIFIED: "udyam_otp_verified",
      UDYAM_OTP_FAILED: "udyam_otp_failed",
      UDYAM_SELECTED: "udyam_selected",
    },
  };
  const methods = {
    registerProperties(event) {
      this.$mixpanel.register(event);
    },
    // registerProperties(mixpanel) {
    //   mixpanel.register({
    //     platform: 'web',
    //     m_code: 'default',
    //   });
    // },
    trackUuid(uuid) {
      this.$mixpanel.identify(uuid);
    },
    trackEvent(event, payload) {
      this.$mixpanel.track(event, payload);
    },
    trackUserProfile(payLoad) {
      this.$mixpanel.people.append(payLoad);
    }
  };

export default { analytics, methods };
